import React from 'react';
import { withRouter } from 'react-router-dom';
import { api_route, user_logout } from '../../helpers/Global';
import alertify from 'alertifyjs';
import 'alertifyjs/build/css/alertify.min.css';
import 'alertifyjs/build/css/themes/default.min.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.min.css';
import TextField from '@material-ui/core/TextField';

class ColisCall extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            coli: (props.coli || {}),
            liste_statuts: [],
            liste_statuts_values: [],
            type_motif_category: '',
            type_motif: '',
            date_reported: '',
            slugan_statut: '',
            call_comment: '',
            date_livraison_souhaitee: ''
        }
    }

    componentDidMount() {

        if (this.props.call_type === 'echec') {
            this.props.setCurrentPage('echec_coli_motif');
        } else if (this.props.call_type === 'call') {
            this.props.setCurrentPage('call_coli');
        }

        var statuts_shippeds = this.props.liste_statuts;
        if (this.props.call_type === 'call') {
            statuts_shippeds['client_demande_livrer'] = { 'Oui': 'Oui' };
        }
        var liste_statuts = Object.keys(statuts_shippeds) || [];

        // order liste_statuts
        var liste_statuts_sorted = [];
        var inc = 1;
        if (this.props.call_type === 'call') {
            inc = 3;
            liste_statuts.forEach(function (item, i) {
                if (item === "client_demande_livrer") {
                    liste_statuts_sorted[0] = item;
                } else if (item === "shipped_injoignable") {
                    liste_statuts_sorted[1] = item;
                } else if (item === "shipped_reported") {
                    liste_statuts_sorted[2] = item;
                } else {
                    liste_statuts_sorted[inc] = item;
                    inc += 1;
                }
            });
            liste_statuts = liste_statuts_sorted;

        } else if (this.props.call_type === 'echec') {
            liste_statuts_sorted = [];
            inc = 2;
            liste_statuts.forEach(function (item, i) {
                if (item === "shipped_injoignable") {
                    liste_statuts_sorted[0] = item;
                } else if (item === "shipped_reported") {
                    liste_statuts_sorted[1] = item;
                } else {
                    liste_statuts_sorted[inc] = item;
                    inc += 1;
                }
            });
            liste_statuts = liste_statuts_sorted;
        }

        //const type_motif_category = liste_statuts[0];
        //const liste_statuts_values = (Object.values(statuts_shippeds) || []);
        this.setState({
            liste_statuts: liste_statuts,
            //liste_statuts_values: liste_statuts_values
            //type_motif_category: type_motif_category,
            //type_motif: liste_statuts_values[0]
        });
    }

    render() {
        const liste_statuts = this.state.liste_statuts;
        
        var today = new Date();
        var current_time = today.getHours() + ":" + today.getMinutes();
       
        return (
            <React.Fragment>
                <div className="row">
                    <div className="container">
                        <div className="card shadow-sm border-0 mb-4">
                            <div className="card-header border-0 gradient-pink p-0">
                                <div className="row">
                                    {this.props.call_type === 'call' ? (
                                        <div className="col text-center py-4">
                                            <h3>Réponse du client</h3>
                                            <p className="text-mute">Sélectionnez une réponse</p>
                                        </div>
                                    ) : (
                                            <div className="col text-center py-4">
                                                <h3>Échec de la livraison</h3>
                                                <p className="text-mute">Sélectionnez une raison</p>
                                            </div>
                                        )}
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="row justify-content-center">
                                    <div className="col-md-10 mx-auto">
                                        {liste_statuts.map((stat) =>
                                            <div className="row" key={stat}>
                                                <div className="col-lg-12 col-md-12">
                                                    <div className="form-group">
                                                        <h6 className="mb-2 mt-4">{this.getCategotyText(stat)}</h6>

                                                        {this.listeStatutsValues(stat).map((typ, indice) =>
                                                            <React.Fragment key={typ}>
                                                                <div className="custom-control custom-radio ml-2 mb-1" >
                                                                    <input
                                                                        type="radio"
                                                                        name="type_motif"
                                                                        className="custom-control-input"
                                                                        onChange={() => this.changeTypeMotif(typ, stat)}
                                                                        checked={this.state.type_motif === typ && this.state.type_motif_category === stat}
                                                                        id={`radio-${stat + indice}`}
                                                                    />
                                                                    <label className="custom-control-label" htmlFor={`radio-${stat + indice}`}>{typ}</label>
                                                                </div>

                                                                {(this.state.type_motif === 'Autre' && typ === 'Autre' && this.state.type_motif_category === stat) && (
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Description"
                                                                        onChange={this.changeAutreDescription}
                                                                    />
                                                                )}

                                                            </React.Fragment>
                                                        )}

                                                        {(this.state.type_motif_category === 'shipped_reported' && stat === 'shipped_reported') && (
                                                            <div className="mb-2 mt-2">
                                                                <DatePicker
                                                                    className="form-control"
                                                                    selected={this.state.date_reported}
                                                                    placeholderText="Prochaine date de livraison"
                                                                    onChange={this.changeDateReported}
                                                                    dateFormat="dd/MM/yyyy"
                                                                />
                                                            </div>
                                                        )}

                                                        {(this.state.type_motif_category === 'client_demande_livrer' && stat === 'client_demande_livrer') && (
                                                            <TextField
                                                                id="time"
                                                                className="form-control"
                                                                type="time"
                                                                defaultValue= {current_time}
                                                                InputLabelProps={{
                                                                  shrink: true,
                                                                }}
                                                                onChange={this.changeDateSouhaitee}
                                                                inputProps={{
                                                                  step: 300, // 5 min
                                                                }}
                                                              />
                                                        )}

                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {this.props.call_type === 'call' && (
                                            <div className="row ">
                                                <div className="col-lg-12 col-md-12">
                                                    <div className="form-group ">
                                                        <h6 className="mb-2 mt-4">Commentaire </h6>
                                                        <div className="custom-control pl-0">
                                                            <textarea className="form-control" placeholder="Écrivez votre commentaire ici" onChange={this.changeCallComment}></textarea>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                    </div>
                                </div>
                            </div>
                            <div className="card-footer">
                                {/* <button type="button" className="btn btn-secondary float-left" onClick={this.props.initCallAction}>Précédent</button> */}
                                <button type="button" className="btn btn-info float-right" id="btnSumitColi" onClick={() => this.submit()}>Valider</button>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }

    submit = () => {
        this.props.loaderDisplay(true);
        const coli = this.state.coli;
        let formData = new FormData();
        formData.append('barecode', coli.barecode);
        formData.append('statut', this.state.type_motif_category);
        formData.append('slugan_statut', (this.state.slugan_statut ? this.state.slugan_statut : this.state.type_motif));
        if (this.state.date_reported) {
            var date_reported = this.state.date_reported;
            var dd = date_reported.getDate();
            var mm = date_reported.getMonth()+1; 
            var yyyy = date_reported.getFullYear();
            if(dd < 10) { dd = '0' + dd; } 
            if(mm < 10) { mm = '0' + mm; }
            date_reported = dd+'-'+mm+'-'+yyyy;
            formData.append('date_reported', date_reported);
        }

        if (this.state.date_livraison_souhaitee) {
            var date_livraison_souhaitee = this.state.date_livraison_souhaitee;
            /*var dd = date_livraison_souhaitee.getDate();
            var mm = date_livraison_souhaitee.getMonth()+1; 
            var yyyy = date_livraison_souhaitee.getFullYear();
            if(dd < 10) { dd = '0' + dd; } 
            if(mm < 10) { mm = '0' + mm; }
            date_livraison_souhaitee = dd+'-'+mm+'-'+yyyy;*/ 

            formData.append('date_livraison_souhaitee', date_livraison_souhaitee);
        }

        if (this.state.call_comment) {
            formData.append('comment', this.state.call_comment);
        }

        var route_slug = 'change-statut-colis';
        if (this.props.call_type === 'call') {
            route_slug = 'add-call-colis';
        }

        fetch(api_route(route_slug), { method: 'POST', body: formData })
            .then(resp => resp.json())
            .then(resp => {

                this.props.loaderDisplay(false);

                if (resp.response === 'error-connected') {
                    user_logout();
                    this.props.history.push(`/user-logout`);
                }

                if (resp.response === 'error') {
                    alertify.error(resp.message);
                } else if (resp.response === 'success') {
                    if (resp.message) {
                        alertify.success(resp.message);
                    }
                    var redirect_url = `/colis/` + coli.listing_statut;
                    if (coli.listing_statut_shipped) {
                        redirect_url += '?statut_shipped=' + coli.listing_statut_shipped + '&t=' + Date.now();
                    } else {
                        redirect_url += '?t=' + Date.now();
                    }
                    redirect_url += '&loader=false';
                    this.props.history.push(redirect_url);
                    this.props.setCurrentPage('list_colis');
                }
            })
            .catch(err => {
                this.props.loaderDisplay(false);
                this.props.openErrorSystem(true);
            });
    }

    listeStatutsValues = (type) => {
        var liste_statuts_values = Object.values(this.props.liste_statuts[type]) || [];
        if (type !== 'client_demande_livrer') {
            liste_statuts_values.push('Autre');
        }
        return liste_statuts_values
    }

    changeTypeMotif = (typ, cat) => {
        this.setState({
            type_motif_category: cat,
            type_motif: typ,
            slugan_statut: null
        });
    }

    changeDateReported = (dte) => {
        this.setState({ date_reported: dte });
    } 

    changeDateSouhaitee = (dte) => {
        this.setState({ date_livraison_souhaitee: dte.target.value });
    }

    changeCallComment = (event) => {
        this.setState({ call_comment: event.target.value });
    }

    changeAutreDescription = (event) => {
        this.setState({ slugan_statut: event.target.value });
    }

    getCategotyText = (cat) => {
        if (cat === 'shipped_injoignable') return 'Injoignable';
        else if (cat === 'shipped_refused') return 'Refusé par le client';
        else if (cat === 'shipped_reported') return 'À Reporter';
        else if (cat === 'shipped_retours') return 'Retour';
        else if (cat === 'client_demande_livrer') return "Le client veut-il que vous le livriez aujourd'hui ?";
        else if (cat === 'autre') return 'Autre';
        return cat;
    }

}

export default withRouter(ColisCall);